import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "ID", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center justify-content-end" }, " SL trong kho ", -1)
const _hoisted_3 = { class: "text-end mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center justify-content-end" }, "SL Xuất", -1)
const _hoisted_5 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center justify-content-end" }, " SL tối đa được xuất ", -1)
const _hoisted_7 = { class: "text-end mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_9 = { class: "text-end mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Thành tiền")
], -1)
const _hoisted_11 = { class: "text-end mb-0 fw-bolder" }

import { min } from 'lodash';
import { PropType, ref, watch } from 'vue';
import { formatCurrencyAndQuantity } from '@/core/helpers/utils';
import {
  ChenhLechVatTuBienBanResponse,
  IVatTuTrongKhoResponseBase,
  IVatTuXuatKhoResponseBase
} from '@/core/interfaces/ApiResponses';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { VatTuService } from '@/core/services/VatTu.service';
import useVatTu from '@/core/hooks/use-vat-tu';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VatTuXuatKhoThuongTable',
  props: {
  chenhLechVatTuArr: {
    type: Array as PropType<ChenhLechVatTuBienBanResponse[]>,
    default: () => [],
  },
  errors: {
    type: Array as PropType<{
      id: number;
      msg: string;
    }[]>,
    default: () => [],
  },
  idKho: {
    type: Number as PropType<number>,
    required: true,
  },
  items: {
    type: Array as PropType<IVatTuXuatKhoResponseBase[]>,
    required: true,
  },
  isNgoaiDinhMuc: {
    type: Boolean as PropType<boolean>,
    required: true,
  }
},
  emits: ['remove'],
  setup(__props) {

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const props = __props;

const vatTuItems = ref<IVatTuXuatKhoResponseBase[]>(props.items);

const vatTuInKhoItems = ref<IVatTuTrongKhoResponseBase[]>([]);

watch(() => props.items, async () => {
  if (props.items) {
    vatTuItems.value = props.items;

    const idArr = props.items.map(({ id }) => id);

    const { data: { data: { data } } } = await VatTuService.getVatTuInKho({
      idKho: props.idKho,
      vat_tu_ids: idArr,
    });

    vatTuInKhoItems.value = data;
  }
}, { immediate: true, deep: true });

const soLuongInKho = (id: number) => {
  const foundItem = vatTuInKhoItems.value.find(({ id: idVatTuInKho }) => id === idVatTuInKho);

  return foundItem?.pivot.so_luong ? formatCurrencyAndQuantity(+foundItem.pivot.so_luong) : '0.00';
}

const calcThanhTien = (index: number) => {
  const vatTu = vatTuItems.value[index];

  if (vatTu) {
    const donGia = vatTu.pivot.don_gia ? +vatTu.pivot.don_gia : 0;

    return formatCurrencyAndQuantity(+vatTu.pivot.so_luong * donGia, false);
  }
}

const { isTextDangerColumn, isValidLabel } = useVatTu();

const errorClass = (idVatTu: number) => {
  const item = props.errors.find(({ id }) => id === idVatTu);

  return {
    class: item ? 'border border-danger' : '',
    errorMsg: item?.msg ?? '',
  }
}

const soLuongToiDaCoTheXuat = (id_vat_tu: number) => {
  const foundItem = props.chenhLechVatTuArr.find(({ id_vat_tu: id }) => id === id_vat_tu);

  const foundItemInKho = vatTuInKhoItems.value.find(({ id: idVatTuInKho }) => id_vat_tu === idVatTuInKho);

  if (foundItem?.chenh_lech && foundItemInKho?.pivot.so_luong) {
    return min([+foundItem.chenh_lech, +foundItemInKho.pivot.so_luong]);
  }

  if (foundItem?.chenh_lech && !foundItemInKho?.pivot.so_luong) return +foundItem?.chenh_lech

  if (!foundItem?.chenh_lech && foundItemInKho?.pivot.so_luong) return +foundItemInKho.pivot.so_luong;

  return '-';
}



return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    "cell-class-name": _unref(isTextDangerColumn),
    data: vatTuItems.value,
    "scrollbar-always-on": true,
    border: true,
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "STT",
        width: "50"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        property: "id",
        width: "60"
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.id), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "MVT",
        property: "ma_vat_tu",
        width: "70"
      }),
      _createVNode(_component_el_table_column, {
        label: "ĐVT",
        width: "70"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : "-"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Thu hồi",
        width: "70"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_checkbox, {
            modelValue: vatTuItems.value[scope.$index].thu_hoi,
            "onUpdate:modelValue": ($event: any) => ((vatTuItems.value[scope.$index].thu_hoi) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "C/ty duyệt",
        width: "90"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_checkbox, {
            modelValue: vatTuItems.value[scope.$index].cong_ty_duyet,
            "onUpdate:modelValue": ($event: any) => ((vatTuItems.value[scope.$index].cong_ty_duyet) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Trạng thái",
        width: "90"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_unref(isValidLabel)(scope.row)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "100" }, {
        header: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(soLuongInKho(scope.row.id)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "140" }, {
        header: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_input_number, {
              class: _normalizeClass(errorClass(scope.row.id).class),
              style: {"width":"100%"},
              type: "number",
              min: 0.01,
              max: soLuongToiDaCoTheXuat(scope.row.id) !== '-' ? soLuongToiDaCoTheXuat(scope.row.id) : Number.POSITIVE_INFINITY,
              modelValue: vatTuItems.value[scope.$index].pivot.so_luong,
              "onUpdate:modelValue": ($event: any) => ((vatTuItems.value[scope.$index].pivot.so_luong) = $event),
              onFocus: _cache[0] || (_cache[0] = ($event: any) => ($event.target.select()))
            }, null, 8, ["class", "max", "modelValue", "onUpdate:modelValue"]),
            (!!errorClass(scope.row.id).errorMsg)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  class: "box-item ms-2",
                  effect: "dark",
                  content: errorClass(scope.row.id).errorMsg,
                  placement: "top-start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_InfoFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["content"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      (__props.isNgoaiDinhMuc)
        ? (_openBlock(), _createBlock(_component_el_table_column, { key: 0 }, {
            header: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(soLuongToiDaCoTheXuat(scope.row.id) !== '-' ? _unref(formatCurrencyAndQuantity)(soLuongToiDaCoTheXuat(scope.row.id) as number) : '-'), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, { label: "Đơn giá" }, {
        header: _withCtx(() => [
          _hoisted_8
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatCurrencyAndQuantity)(+vatTuItems.value[scope.$index].pivot.don_gia)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _hoisted_10
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_11, _toDisplayString(calcThanhTien(scope.$index)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        width: "50",
        fixed: "right"
      }, {
        default: _withCtx((scope) => [
          _createVNode(ButtonCustom, {
            "button-type": _unref(ButtonsType).TRASH,
            "color-type": _unref(ButtonTypeColors).DANGER,
            onClick: ($event: any) => (_ctx.$emit('remove', scope.row.id))
          }, null, 8, ["button-type", "color-type", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["cell-class-name", "data"]))
}
}

})